"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _I18n = _interopRequireDefault(require("I18n"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _UIFormControl = _interopRequireDefault(require("UIComponents/form/UIFormControl"));

var _UISelect = _interopRequireDefault(require("UIComponents/input/UISelect"));

var _UILink = _interopRequireDefault(require("UIComponents/link/UILink"));

var _link = require("../../constants/link");

var _anchor = require("../../utils/anchor");

var _link2 = require("../../utils/link");

var i18nKey = function i18nKey(suffix) {
  return "RichTextLib.links.linkTypes." + _link.LinkTypes.ANCHOR + "." + suffix;
};

var AnchorLinkField = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2.default)(AnchorLinkField, _PureComponent);
  (0, _createClass2.default)(AnchorLinkField, null, [{
    key: "propTypes",
    get: function get() {
      return {
        fetchAnchors: _propTypes.default.func.isRequired,
        onChange: _propTypes.default.func.isRequired,
        anchor: _propTypes.default.string,
        dropdownClassName: _propTypes.default.string
      };
    }
  }]);

  function AnchorLinkField(props) {
    var _this;

    (0, _classCallCheck2.default)(this, AnchorLinkField);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(AnchorLinkField).call(this, props));

    _this.handleChange = function (_ref) {
      var option = _ref.target.value;

      _this.props.onChange({
        anchorName: option.value
      });
    };

    _this.fetchAnchorLinks = function (input, callback) {
      if (!_this.mounted) return;

      _this.props.fetchAnchors(input).then(function (anchors) {
        var options = [];
        var searchable;

        if (anchors.length) {
          anchors.forEach(function (anchor) {
            options.push({
              text: anchor.id,
              value: anchor.id
            });
          });
          options.sort(_link2.alphabeticalSort);
          searchable = true;
        } else {
          if (input) {
            searchable = true;
          } else {
            options.push({
              text: _I18n.default.text(i18nKey('noAnchorsTitle')),
              disabled: true,
              help: _react.default.createElement(_react.Fragment, null, _react.default.createElement(_FormattedMessage.default, {
                message: i18nKey('noAnchorsHelp')
              }), ' ', _react.default.createElement(_UILink.default, {
                href: (0, _anchor.getHowToCreateAnchorUrl)(),
                external: true
              }, _I18n.default.text(i18nKey('learnMore'))))
            });
            searchable = false;
          }
        }

        _this.setState({
          searchable: searchable
        }, function () {
          callback(null, {
            options: options
          });
        });
      });
    };

    _this.state = {
      searchable: true
    };
    return _this;
  }

  (0, _createClass2.default)(AnchorLinkField, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.mounted = true;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.mounted = false;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          anchor = _this$props.anchor,
          dropdownClassName = _this$props.dropdownClassName;
      return _react.default.createElement(_UIFormControl.default, {
        label: _I18n.default.text(i18nKey('label')),
        className: "m-top-0"
      }, _react.default.createElement(_UISelect.default, {
        dropdownClassName: dropdownClassName,
        "data-test-id": "anchor-link-dropdown",
        searchable: this.state.searchable,
        value: anchor,
        loadOptions: this.fetchAnchorLinks,
        onSelectedOptionChange: this.handleChange,
        placeholder: _I18n.default.text(i18nKey('placeholder'))
      }));
    }
  }]);
  return AnchorLinkField;
}(_react.PureComponent);

exports.default = AnchorLinkField;
module.exports = exports.default;